module.exports = __webpack_public_path__ + "img/포트리스 (2).3b055ed9.png";